import { Next } from '@securitize/ui-components';

export const GET_OPPORTUNITY_DEPOSIT_ADDRESSES = (opportunityId) => new Next(`/opportunities/${opportunityId}/deposits`,
  'GET_OPPORTUNITY_DEPOSIT_ADDRESSES');
